function sessionCheck() {
  const storedUserData = localStorage.getItem("access_data");

  try {
    if (storedUserData) {
      const parsedData = JSON.parse(storedUserData);
      if (parsedData.username && parsedData.login_id) {
        return storedUserData;
      } else {
        return null;
      }
    } else {
      return null;
    }
  } catch (e) {
    console.error("Error parsing user data:", e);
    return null;
  }
}

export default sessionCheck;